import React from "react";

function Card({ item }) {
 

  
  return (
    <>
   
      <div className="card-box">
        {/* Stars */}
        <div className="card-top">
          <div className="stars">
            {Array.from({ length: item?.rating || 0 }).map((_, index) => (
              <span className="text-warning" key={index}>★</span>
            ))}
          </div>
        </div>

        {/* Message */}
        <p className="card-text">"{item?.message || ""}"</p>

        {/* User */}
        <div className="card-bottom">
          <div className="user-profile">
            <div className="user-avatar">
              {item?.customer_name?.charAt(0) || "U"}
            </div>

            <div className="user-details">
              <span className="u-name">{item?.customer_name || ""}</span>
              <span className="u-designation">{item?.designation || ""}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
